import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: stretch;

      gap: 1rem;

      margin-top: 1rem;
    `;
  }};
`;

export const PriceContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;

      flex-grow: 1;

      sup {
        font-size: 0.75rem;
        top: -1rem;
      }
    `;
  }};
`;

export const BadgesGroup = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      gap: 1rem;
    `;
  }};
`;

export const PackageAttributes = styled.div`
  ${({ theme, ...props }) => {
    return css`
      border: 1px solid ${theme.color.neutral_200};
      border-radius: ${theme.radius.xs};
      width: 100%;
      padding: 1rem;
    `;
  }};
`;
